// Button

export default function Button({
  children,
  href,
  type = "button",
  variant = "primary",
  disabled = false,
  className = "",
  onClick,
}) {
  const baseClasses =
    "inline-flex items-center justify-center px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] transition disabled:cursor-not-allowed disabled:opacity-40";

  const variants = {
    primary:
      "bg-amber-flame-500 text-twilight-indigo-950 hover:bg-amber-flame-400 focus:outline-none focus:ring-2 focus:ring-amber-flame-300 focus:ring-offset-2 focus:ring-offset-twilight-indigo-950",
    secondary:
      "border border-white/20 text-white hover:border-amber-flame-500 hover:text-amber-flame-400 focus:outline-none focus:ring-2 focus:ring-amber-flame-300 focus:ring-offset-2 focus:ring-offset-twilight-indigo-950",
    dark:
      "border border-white/10 bg-twilight-indigo-950 text-white hover:border-amber-flame-500 hover:text-amber-flame-400 focus:outline-none focus:ring-2 focus:ring-amber-flame-300 focus:ring-offset-2 focus:ring-offset-twilight-indigo-950",
  };

  const classes = `${baseClasses} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={classes}
    >
      {children}
    </button>
  );
}